import { RawDataItem, ChartNodeType, ChartNode } from './funnel-chart-types';
import config from './funnel-chart-config.json';

export const createNodes = (
  data: RawDataItem[],
  svgWidth: number,
  svgHeight: number,
  totalHeight: number,
  totalValue: number,
  nodeType: ChartNodeType,
  minNodeHeight?: number,
): ChartNode[] => {
  let prevNodeYOffset = 0;
  const strokeWidth = calculateStrokeWidth(data.length);

  const nodes = data.map(rawData => {
    const node = createNode(
      nodeType === ChartNodeType.Start ? rawData.startValue : rawData.endValue,
      svgWidth,
      svgHeight,
      totalHeight,
      totalValue,
      rawData.name,
      rawData.color,
      prevNodeYOffset,
      nodeType,
      strokeWidth,
      minNodeHeight,
    );

    // Since nodes have a minHeight option, we need to calculate the available height based on the node's height
    // instead of passing totalHeight as a static value
    // availableHeight -= node.height;
    prevNodeYOffset += node.height;
    return node;
  });
  return nodes;
};

const createNode = (
  value: number,
  svgWidth: number,
  svgHeight: number,
  availableHeight: number,
  totalValue: number,
  name: string,
  color: string,
  prevNodeYOffset: number,
  nodeType: ChartNodeType,
  strokeWidth: number,
  minNodeHeight?: number,
): ChartNode => {
  const relativeValue = value / totalValue;
  const height = calculateNodeHeight(
    availableHeight,
    relativeValue,
    minNodeHeight,
  );
  const x = nodeType === ChartNodeType.Start ? 0 : svgWidth - config.node.width;
  const y = svgHeight - prevNodeYOffset - height;

  return {
    name,
    color,
    width: config.node.width,
    height,
    x,
    y,
    value,
    strokeWidth,
  };
};

const calculateNodeHeight = (
  availableHeight: number,
  relativeValue: number,
  minNodeHeight: number = 0,
): number => {
  const height = availableHeight * relativeValue;
  if (height >= minNodeHeight) {
    return height;
  }

  return minNodeHeight;
};

const calculateStrokeWidth = (nodes: number): number => {
  const padding = (nodes - 1) * config.node.blockPadding;
  const perNodePadding = padding / nodes;
  return perNodePadding / 2;
};
